import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { StyledCompactWrapper, StyledInput, StyledSelect } from './styled'

const NAME = 'name'
const NPI = 'npi'
const searchTypeOptions = [
  { value: NAME, label: 'Name' },
  { value: NPI, label: 'NPI' }
]

const ProviderNameSearch = ({
  filterValues = {},
  filtersUpdateSeveral,
  onChange = false
}) => {
  const [searchType, setSearchType] = useState(NAME)
  const [searchValue, setSearchValue] = useState()

  const onChangeSearchType = v => {
    filtersUpdateSeveral([{ name: null }, { npi: null }])
    setSearchType(v)
    setSearchValue(undefined)
  }

  const onChangeSearch = e => {
    const value = e?.target?.value

    if (searchType === NPI) {
      if (value.length > 10) return false

      setSearchValue(value)

      if (!value.length || value.length === 10) {
        if (onChange) onChange(searchType, value)
      }
    } else {
      setSearchValue(value)
      if (onChange) onChange(searchType, value)
    }
  }

  useEffect(() => {
    if (filterValues) {
      if (filterValues[NPI]) {
        setSearchType(NPI)
        setSearchValue(filterValues[NPI])
      } else if (filterValues[NAME]) {
        setSearchType(NAME)
        setSearchValue(filterValues[NAME])
      }
    }
    // eslint-disable-next-line
  }, [JSON.stringify(filterValues)])

  return (
    <StyledCompactWrapper>
      <StyledSelect
        value={searchType}
        defaultValue="name"
        onChange={onChangeSearchType}
        options={searchTypeOptions}
        data-test="providersPageSearchMode"
      />
      <StyledInput
        suffix={
          searchType === NPI && (
            <Tooltip title="NPI consists of 10 numbers">
              <InfoCircleOutlined
                style={{ color: 'rgba(0,0,0,.45)' }}
                data-test="npiTooltip"
              />
            </Tooltip>
          )
        }
        type={searchType === NPI ? 'number' : 'text'}
        placeholder={searchType === NPI ? 'NPI' : 'Name'}
        onChange={onChangeSearch}
        value={searchValue}
        data-test="providersPageSearch"
        allowClear
        onWheel={e => searchType === NPI && e.currentTarget.blur()}
        fontSize={16}
      />
    </StyledCompactWrapper>
  )
}

ProviderNameSearch.propTypes = {
  filterValues: PropTypes.object,
  filtersUpdateSeveral: PropTypes.func.isRequired,
  onChange: PropTypes.func
}

export default ProviderNameSearch
